
export default {
    name: 'FilterModal',

    props: {
        filterTitle: {
            type: String,
            required: true,
            default: '',
        },
        actualValue: {
            required: true,
        },
        filterOptions: {
            type: Array,
            required: true,
            default: () => [],
        },
    },

    data() {
        return {
            showModal: false,
            returnValue: []
        }
    },

    mounted() {
      // add value back into FilterModal if user directly enter URL with selected feature(s)
      this.$nextTick(() => {
        if(this.actualValue.length > 0) {
          this.returnValue = this.actualValue;
        }
      })
    },
    watch: {
      actualValue(newValue, oldValue) {
        if (newValue.length !== oldValue.length) {
          this.returnValue = this.actualValue;
        }
      }
    },
    computed: {
        isDesktop() {
            return window.innerWidth >= 768;
        }
    },

    updated() {
        this.$emit('returnValue',this.returnValue);
    },

    methods: {
        openModal() {
            this.showModal = true;
            document.body.classList.add('modal-opened'); // Add the class to disable scrolling
        },

        closeModal() {
            this.showModal = false;
            document.body.classList.remove('modal-opened'); // Remove the class to enable scrolling
            window.scrollTo(0,0)
        },

        toggleSelection(option) {
            // Check if the option is already in this.filter.featureTypeValue
            const index = this.returnValue.findIndex(item => item.value === option.value);

            if (index === -1) {
              // Option is not in the array, so add it
              this.returnValue = [...this.returnValue, option];
            } else {
              // Option is in the array, so remove it
              this.returnValue = this.returnValue.filter(item => item.value !== option.value);
            }
        },

        clearSelectedFeatures() {
            this.returnValue = [];
        },

        confirmSelectionAndCloseModal() {
            // console.log('confirmFilter');

            // Close the modal
            this.showModal = false;
            window.scrollTo(0,0)
        }
    },
}
